"use client";
import * as React from "react";
const SvgBoltOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 9 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M3.6 16h-.9l.9-6.22H.45c-.8 0-.3-.67-.28-.7L5.4 0h.9l-.9 6.22h3.16c.36 0 .56.17.36.59z" }));
export {
  SvgBoltOutlined as default
};
